import type {
  ExternalLayerObjectInfoDto,
  ExternalObjectInfoValuesDto,
} from 'cadenza/map/dto/external-layer-object-info-dto';
import type { ObjectInfoElementsDto } from 'cadenza/workbook/model/object-info-elements-dto';

export function createObjectInfoElements(externalLayerObjectInfo: ExternalLayerObjectInfoDto) {
  return externalLayerObjectInfo.objectInfoValues.map((objectInfoValues: ExternalObjectInfoValuesDto, index: number) =>
    createObjectInfo(objectInfoValues, externalLayerObjectInfo, index),
  );
}

function createObjectInfo(
  objectInfoValues: ExternalObjectInfoValuesDto,
  externalLayerObjectInfo: ExternalLayerObjectInfoDto,
  index: number,
): ObjectInfoElementsDto {
  return {
    title: externalLayerObjectInfo.layerName,
    valid: true,
    selectionIndex: index,
    simplifiedGeometry: objectInfoValues.geometry || externalLayerObjectInfo.requestGeometry,
    infoElements: objectInfoValues.values,
    drillThroughDestinations: [],
  };
}
